// @flow
declare var SULU_CONFIG: Object;

export default SULU_CONFIG;
